<template>
<div class="filter">
  <el-input v-model="filterData.name" size="small" placeholder="搜索名称"></el-input>
  <div class="space"></div>
  <el-select v-model="filterData.status" size="small">
    <el-option label="全部" :value="null"></el-option>
    <el-option label="在线" :value="true"></el-option>
    <el-option label="离线" :value="false"></el-option>
  </el-select>
  <div class="space"></div>
  <el-button type="success" @click="filter" size="small">过滤</el-button>
</div>
</template>

<script>
export default {
  name: 'GatewayFIlter',
  props: ['API'],
  data () {
    return {
      filterData: {}
    }
  },
  methods: {
    filter () {
      this.API.filter.filter(this.API.origList)
    }
  },
  created () {
    this.filterData = this.API.filter.filterData
  }
}
</script>

<style lang="scss" scoped>
.filter{
  display: flex;
  .space {
    margin: 0 10px;
  }
}
</style>
